import React from 'react';
import {Form, Grid} from 'semantic-ui-react';
import _ from 'lodash';
import {convertValueToDollar, formatDollarDecimalsNullSafe} from 'common/utils';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {safeAdd} from 'common/utils';
import {InlineDollarFieldForm as InlineDollarField} from 'app-ui-componentlibrary';

export class BudgetSummaryPanel extends React.Component {
  constructor(props) {
    super(props);
    const appShare = _.get(props.budgetShare, 'appShare');
    this.state = {
      appShare: appShare,
    };
  }

  componentDidUpdate(prevProps) {
    const {costShareInformation, budgetShare} = this.props;
    const waiverDetermination = _.get(costShareInformation, 'waiverDetermination');
    const waiverDeterminationAttachmentLength = _.size(
      _.get(costShareInformation, 'waiverDeterminationAttachment')
    );
    const appShareUpdated = _.get(budgetShare, 'appShareUpdated');
    const appShareFromBudget = _.get(budgetShare, 'appShare');

    if (
      waiverDetermination === 'Approved' &&
      waiverDeterminationAttachmentLength > 0 &&
      !appShareUpdated
    ) {
      this.handleUpdateBudgetShare({
        appShare: 0,
        originalAppShare: appShareFromBudget,
        appShareUpdated: true,
      });
    } else if (
      (waiverDetermination !== 'Approved' || waiverDeterminationAttachmentLength < 1) &&
      appShareUpdated
    ) {
      this.handleUpdateBudgetShare({
        appShare: _.get(budgetShare, 'originalAppShare'),
        appShareUpdated: false,
      });
    }
    if (!appShareUpdated && this.state.appShare !== appShareFromBudget) {
      this.setState({
        appShare: appShareFromBudget,
      });
    }
  }

  handleUpdateBudgetShare(newbudgetShare) {
    const {saveEntityData, budgetShare} = this.props;
    saveEntityData(
      'context.awardRecommendation.payload.budget.share',
      'awardRecommendation',
      {
        ...budgetShare,
        ...newbudgetShare,
      }
    );
    this.setState({
      appShare: _.get(newbudgetShare, 'appShare'),
    });
  }

  renderBudgetSummary() {
    const stateAppShare = this.state.appShare;
    const appShare = stateAppShare
      ? stateAppShare
      : _.get(this.props, 'budgetShare.appShare');
    const originalAppShare = _.get(this.props, 'budgetShare.originalAppShare');
    const waiverDetermination = _.get(
      this.props,
      'costShareInformation.waiverDetermination'
    );
    const waiverDeterminationAttachment = _.get(
      this.props,
      'costShareInformation.waiverDeterminationAttachment'
    );
    const errorMessage = `Enter a value less than the original Non-federal resources value of ${convertValueToDollar(
      originalAppShare
    )}`;

    if (waiverDetermination === 'Approved' && !_.isEmpty(waiverDeterminationAttachment)) {
      return (
        <Form.Field>
          <InlineDollarField
            name="appShare"
            value={appShare}
            alignLeft
            handleBlur={() =>
              this.handleUpdateBudgetShare({
                appShare: formatDollarDecimalsNullSafe(this.state.appShare),
              })
            }
            handleChange={(name, value) => this.setState({appShare: value})}
            displayError={appShare > originalAppShare}
            errorMessages={errorMessage}
          />
        </Form.Field>
      );
    } else {
      return <strong>{convertValueToDollar(appShare)}</strong>;
    }
  }

  render() {
    const fedShare = _.get(this.props, 'budgetShare.fedShare');
    const appShare = _.get(this.props, 'budgetShare.appShare');
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width="6">Federal resources</Grid.Column>
          <Grid.Column width="10">
            <strong>{convertValueToDollar(fedShare)}</strong>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="6">Non-federal resources</Grid.Column>
          <Grid.Column width="10">{this.renderBudgetSummary()}</Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width="6">Total budget</Grid.Column>
          <Grid.Column width="10">
            <strong>{convertValueToDollar(safeAdd(fedShare, appShare))}</strong>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default connectDynamic(BudgetSummaryPanel);
